import React, { Component } from 'react';
import { Form, Field } from 'react-final-form';
import { renderRadioTabGroup, renderUsageType } from './fields';
import { FormattedMessage } from 'react-intl';
import { bookingTypeOptions, usageOptions } from '../../constants/options';

class TripType extends Component {
  constructor(props) {
    super(props);
    this.handleClose = this.handleClose.bind(this);
    this.handleCancel = this.handleCancel.bind(this);
  }

  renderUsagesType() {
    const { messages, contract, user } = this.props;

    if (contract.privateCarSharing && contract.businessCarSharing && user)
      return (
        <Field
          name="usageTypes"
          component={renderUsageType}
          options={usageOptions(messages)}
        />
      );
  }

  renderBookingType() {
    const { messages, contract } = this.props;

    if (
      contract.interfaceConfig.oneWayDisplay &&
      contract.interfaceConfig.returnTripDisplay
    )
      return (
        <Field
          name="tripType"
          component={renderRadioTabGroup}
          options={bookingTypeOptions(messages)}
        />
      );
  }

  // Closes the parent react-bootstrap DropdownButton by simulating an outside
  // click on a real Element (body) — document has no classList, so dispatching
  // there threw "Cannot read properties of undefined (reading 'contains')".
  // Deferred to the next tick so it runs AFTER the form submit / re-render settles:
  // a synchronous body.click() races the closing dropdown and react-bootstrap's
  // root-close handler then reads `.contains` on an unmounted ref and throws (seen
  // on booking confirm). The try/catch is a final guard for that race.
  // Cleaner long-term fix: controlled DropdownButton + onClose from FiltersBookings.
  handleClose() {
    setTimeout(() => {
      try {
        document.body.click();
      } catch (e) {
        // dropdown already closed/unmounted — nothing left to close
      }
    }, 0);
  }

  handleCancel(form) {
    form.reset();
    this.handleClose();
  }

  render() {
    const { initialValues, onSubmit } = this.props;

    return (
      <Form onSubmit={onSubmit} initialValues={initialValues}>
        {({ handleSubmit, form }) => (
          <div>
            <form className="form-content" noValidate onSubmit={handleSubmit}>
              {this.renderUsagesType()}
              {this.renderBookingType()}
              <div className="actions-wrapper">
                <a
                  onClick={(event) => {
                    event.preventDefault();
                    this.handleCancel(form);
                  }}
                  href="#cancel-trip-type"
                  className="secondary-bg"
                >
                  <FormattedMessage id="generic.cancel" />
                </a>
                <button
                  className="btn-save primary-btn"
                  type="submit"
                  onClick={this.handleClose}
                >
                  <FormattedMessage id="generic.save" />
                </button>
              </div>
            </form>
          </div>
        )}
      </Form>
    );
  }
}

export default TripType;
